import React, { useContext } from 'react'
import './style/Q3.css'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import YesOrNoQuestion from '../YesOrNoQuestion'
import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import StepCounter from '../StepCounter'
import gif6 from './assets/14_box 2.gif'
import jpg6 from './assets/static/14_box-2.jpg'

import '../Gif.css'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q9() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const { translate } = useLocalize()

    return (
        <>
            <div className="picHold hid vis">
                <img className="gif6" src={settings.isAnimationPause ? jpg6 : gif6} />
            </div>
            <Headling text={translate('Overdrafts')} />
            <Subtitle text={translate('Can I have an overdraft on my account?') + ' '  + translate('(account credit line)')} />
            <YesOrNoQuestion onYesClick={() => {
                setNewAnswer({
                    6: 1
                })
                history.push('/Q/7')
                ReactPixel.trackCustom('minus_yes', '');
            }}
                onNoClick={() => {
                    setNewAnswer({
                        6: 0
                    })
                    history.push('/Q/7')
                    ReactPixel.trackCustom('minus_no', '');
                }} />
            <StepCounter />
        </>
    )
}



export default Q9

